import { propertyEnrichmentApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PROPERTY_ENRICHMENT_ACTION_TYPE = createNamedActions(
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/propertyEnrichment`,
  {
    FETCH_PROPERTY_ENRICHMENT_START: 'FETCH_PROPERTY_ENRICHMENT_START',
    GET_PROPERTY_ENRICHMENT: 'GET_PROPERTY_ENRICHMENT',
    FETCH_PROPERTY_ENRICHMENT_FAILED: 'FETCH_PROPERTY_ENRICHMENT_FAILED',
    RESET_PROPERTY_ENRICHMENT: 'RESET_PROPERTY_ENRICHMENT',
  },
);

export const getPropertyEnrichmentAction = catchAsyncActionError(
  ({ reapiPropertyId, address }) =>
    async dispatch => {
      dispatch({ type: PROPERTY_ENRICHMENT_ACTION_TYPE.FETCH_PROPERTY_ENRICHMENT_START });

      try {
        const { data } = await propertyEnrichmentApi.getPropertyEnrichment({
          reapiPropertyId,
          address,
        });

        return dispatch({
          type: PROPERTY_ENRICHMENT_ACTION_TYPE.GET_PROPERTY_ENRICHMENT,
          payload: data,
        });
      } catch {
        // Enrichment is a best-effort lookup: a placeholder/incomplete address makes the
        // backend return 404, which is an expected outcome surfaced via the empty state —
        // never an error toast. Resolve instead of rethrowing so catchAsyncActionError
        // does not show the server message.
        return dispatch({ type: PROPERTY_ENRICHMENT_ACTION_TYPE.FETCH_PROPERTY_ENRICHMENT_FAILED });
      }
    },
);

/** Used by PropertyEnrichmentDrawer to persist the provider property ID after initial lookup. */
export const updateReapiPropertyIdAction = catchAsyncActionError(
  ({ propertyId, reapiPropertyId }) =>
    async () => {
      await propertyEnrichmentApi.updateReapiPropertyId({
        propertyId,
        reapiPropertyId,
      });
    },
);

export const resetPropertyEnrichmentAction = () => ({
  type: PROPERTY_ENRICHMENT_ACTION_TYPE.RESET_PROPERTY_ENRICHMENT,
});
